import { FrontendFunc } from "@/models/frontend-func";

export class SharedFuncReference {
	FuncID:number = 0;
	Alias:string = "";
	SharedFunc:FrontendFunc = new FrontendFunc();

	public constructor(data?:any){
		if (!data) return;
		this.FuncID = data.FuncID;
		this.Alias = data.Alias;
		this.SharedFunc = new FrontendFunc(data.SharedFunc);
	}

	public getJSON(){
		return {
			FuncID: this.FuncID,
			Alias: this.Alias,
			SharedFunc: this.SharedFunc.getJSON()
		};
	}
}